import { useMutation } from '../';
import { deleteService2portfolioMutation } from '../mutations';

export function useDeleteService2portfolioMutation() {
  const { data, isLoading, mutate } = useMutation();
  
  const mutateDeleteService2portfolio = (variables) => {
    mutate(deleteService2portfolioMutation, variables);
  };

  return { data, isLoading, mutateDeleteService2portfolio };
}
